(function () {
  'use strict';

  angular
    .module('service.app', [])

    /* @ngInject */
    .factory('AppService', ["$http", "$rootScope", "$q", "$timeout", "HttpService", "toastr", function ($http, $rootScope, $q, $timeout, HttpService, toastr) {
      var _this = this,
        appPromise,
        cartRequests = [],
        translate;
      this.getParams = function (refresh) {
        refresh = refresh || false;
        if (refresh || angular.isUndefined(appPromise)) {
          appPromise = $http({
            method: 'GET',
            url: '/App' + (refresh ? '?' + (new Date().getTime()) : ''), // Fix IE11 cache
            headers: {
              'Content-type': 'application/json',
              'X-Requested-With': 'jsonHttpRequest'
            }
          })
          .then(function (response) {
            var data = _.cloneDeep(response.data.VisitorContext);
            data.Visitor.isPro = false;
            if (response.data.WebsiteVisitorContext && response.data.WebsiteVisitorContext.VisitorIsPro) {
              data.Visitor.isPro = response.data.WebsiteVisitorContext.VisitorIsPro;
            }
            return data;
          })
          .catch(function (error) {
            throw error;
          });
        }
        return appPromise;
      };
      this.updateParams = function (data, noevent) {
        appPromise = $q.resolve(data);
        if (noevent) return;
        $rootScope.$broadcast('cartUpdate');
      };
      this.getTranslate = function () {
        if (typeof translate === 'undefined') {
          translate = $http({
            method: 'GET',
            url: '/Template/Translate/Translate',
            headers: {
              'Content-type': 'application/json',
              'X-Requested-With': 'jsonHttpRequest'
            }
          })
          .then(function (response) {
            return response.data;
          })
          .catch(function (error) {
            throw error;
          });
        }
        return translate;
      };
      this.addToCart = function (products) {
        var url = '/Product/AddToCart';
        var productsToCart = {
          Products: []
        };

        _.each(products, function (product) {
          productsToCart.Products.push({
            IDLine: product.idLine || 0,
            IDProduct: product.idProduct || 0,
            Reference: product.Reference || '',
            Quantity: product.quantity,
            Comment: product.Comment || '',
            Elements: product.Elements || null,
            Customization: product.Customization || null
          });
        });
        var tmpId = new Date().getTime();
        cartRequests.push({id: tmpId});
        return $http({
          method: 'POST',
          url: url,
          headers: {
            'Content-type': 'application/json',
            'X-Requested-With': 'jsonHttpRequest'
          },
          data: productsToCart
        })
        .then(function (response) {
          _.pullAllBy(cartRequests, [{ id: tmpId }], 'id');
          return response.data;
        })
        .catch(function (error) {
          throw error;
        });
      };
      this.deleteLine = function (idLine, designation, img, message, fromCart) {
        $rootScope.$broadcast('showPageLoader', true);
        HttpService.get({
          url: '/RemoveCartLine/' + idLine,
          cache: false
        })
        .then(function (response) {
          if (response.status === 'OK') {
            _this.updateParams(response.results);
            toastr.success(designation, message, {
              allowHtml: true,
              extraData: {
                template: 'toast_addtocart.tpl',
                data: {
                  img: img
                }
              }
            });
            if (fromCart && !response.results.Cart.Products.length) {
              $rootScope.$broadcast('showPageLoader', true);
              $timeout(function () {
                $rootScope.$broadcast('showPageLoader', true);
              }, 450);
              window.location = $rootScope.backToStore;
            }
          } else {
            _this.getTranslate()
              .then(function (messages) {
                toastr.warning(messages.errors.TryLater, messages.errors.ErrorHasOccurred, {
                  allowHtml: true,
                  extraData: {
                    template: 'toast_message.tpl'
                  }
                });
              })
              .catch(function (error) {
                console.error(error);
              });
          }
          $rootScope.$broadcast('showPageLoader', false);
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.itemQuantityInCart = function (id, hash) {
        hash = hash || '';
        return this.getParams()
          .then(function (data) {
            if (!data.HasCart) return 0;
            var qty = 0;
            _.each(data.Cart.Products, function (product) {
              if (product.IDProduct === id) {
                if (hash !== '') {
                  if (product.Comment === hash) {
                    qty = product.Quantity;
                    return false;
                  }
                } else {
                  qty = product.Quantity;
                  return false;
                }
              }
            });
            return qty;
          })
          .catch(function (error) {
            console.error(error);
          });
      };
      this.checkAvailability = function () {
        return HttpService.post({
          url: '/Cart/checkAvailability'
        })
        .then(function (response) {
          return response;
        })
        .catch(function (error) {
          console.error(error);
        });
      };
      this.getProductPrice = function (priceObj, qty) {
        if (!priceObj.prices) {
          var prices = [{
            qty: 1,
            range: [0],
            HasDiscount: priceObj.HasDiscount,
            Discount: priceObj.Discount,
            HTDiscountedPrice: priceObj.HTDiscountedPrice,
            TTCDiscountedPrice: priceObj.TTCDiscountedPrice,
            HTPrice: priceObj.HTPrice,
            TTCPrice: priceObj.TTCPrice
          }];
          if (priceObj.DegressivePrice) {
            var i = 0;
            _.each(priceObj.DegressivePrice, function (item, key) {

              prices[i].range.push(Number(key));

              prices.push({
                qty: Number(key),
                range: [Number(key)],
                HasDiscount: item.HasDiscount,
                Discount: item.Discount,
                HTDiscountedPrice: item.HTDiscountedPrice,
                TTCDiscountedPrice: item.TTCDiscountedPrice,
                HTPrice: item.HTPrice,
                TTCPrice: item.TTCPrice
              });

              i++;
            });
          }
          priceObj.prices = prices;
        }
        var current = {};
        _.each(priceObj.prices, function (price) {
          if (_.inRange(qty, price.range[0], price.range[1] || 10000)) {
            current = price;
            return false;
          }
        });
        return current;
      };
      this.updateStore = function (visitorContext) {
        appPromise.$$state.value.Store = visitorContext.Store;
        appPromise.$$state.value.Visitor.Store = visitorContext.Visitor.Store;
      };
      return {
        getParams: this.getParams,
        updateParams: this.updateParams,
        getTranslate: this.getTranslate,
        addToCart: this.addToCart,
        deleteLine: this.deleteLine,
        itemQuantityInCart: this.itemQuantityInCart,
        checkAvailability: this.checkAvailability,
        getProductPrice: this.getProductPrice,
        cartRequests: cartRequests,
        updateStore: this.updateStore
      };
    }]);

})();
